import dayIsNowDayBefore from './dayIsNowDayBefore';
import dayIsSameDay from './dayIsSameDay';
import dayIsNowDayAfter from './dayIsNowDayAfter';

const sortAvailabilityTimesInConsumerTimeByConsumerDays = (availabilityTimeBlockInConsumerTime, day, availabilityInConsumerTime) => {
    availabilityTimeBlockInConsumerTime.map((dayOfBlocks, i) => {
        // 'i' tells us that time zone conversion has moved timeBlocks to a past day/date(0) or a future day/date(2)
        if (dayOfBlocks.length > 0) {
            if (dayIsNowDayBefore(i)) {
                const pastDay = (day === 1) ? 7 : (parseInt(day, 10) - 1).toString();
                if (!availabilityInConsumerTime[pastDay]) {
                    availabilityInConsumerTime[pastDay] = [...dayOfBlocks];
                }
                else {
                    availabilityInConsumerTime[pastDay].push(...dayOfBlocks);
                };
            }
            if (dayIsSameDay(i)) {
                if (!availabilityInConsumerTime[day]) {
                    availabilityInConsumerTime[day] = [...dayOfBlocks];
                }
                else {
                    availabilityInConsumerTime[day].push(...dayOfBlocks);
                };
            }
            if (dayIsNowDayAfter(i)) {
                const nextDay = (day === 7) ? 1 : (parseInt(day, 10) + 1).toString();
                if (!availabilityInConsumerTime[nextDay]) {
                    availabilityInConsumerTime[nextDay] = [...dayOfBlocks];
                }
                else {
                    availabilityInConsumerTime[nextDay].push(...dayOfBlocks);
                };
            };
        };
    });
    return availabilityInConsumerTime;
};

export default sortAvailabilityTimesInConsumerTimeByConsumerDays;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/sortAvailabilityTimesInConsumerTimeByConsumerDays.js